import React from 'react';
import NoData from './noData';
import CategoryInput from './categoryInput';
import Loading from './loading';

const CardCategory = props => {
  const {
    categoryId,
    categories,
    handleGetTagsByCategoryId,
    language,
    languageFilters,
    loading
  } = props;
  return (
    <div className="card-container category-card-container">
      <div className="header-one">
        <div className="item-right">
          <h5>{language.card.list.title}</h5>
        </div>
      </div>
      <div className="header-two">
        <div className="header-two-item-right">
          <h5>{language.card.list.name}</h5>
        </div>
      </div>
      <div className={categories.datos.length > 0 ? 'card-content-input' : 'card-content'}>
        {categories.datos.length > 0 ? (
          <CategoryInput
            categoryId={categoryId}
            categories={categories}
            handleGetTagsByCategoryId={handleGetTagsByCategoryId}
            language={language}
            languageFilters={languageFilters}
          />
        ) : (
          <NoData legend={language.card.list.legend} />
        )}
        {loading && <Loading />}
      </div>
    </div>
  );
};

export default CardCategory;



// WEBPACK FOOTER //
// ./source/client/components/account_tag/cardCategory.jsx